import { render, staticRenderFns } from "./PrePostDeliver.vue?vue&type=template&id=314be145"
import script from "./PrePostDeliver.vue?vue&type=script&lang=js"
export * from "./PrePostDeliver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports